<script setup lang="ts">
import type { ScaleLinear } from 'd3';

const props = defineProps<{
  loading: boolean;
  yScale: ScaleLinear<number, number, never>;
  customTicks?: number[];
}>();

const ticksToUse = computed(() => props.customTicks || props.yScale.ticks(8));
</script>
<template>
  <svg class="h-full w-full relative" viewBox="0 0 100 100" preserveAspectRatio="none">
    <template v-if="!loading">
      <g v-for="(value, i) in ticksToUse" :key="i" :transform="`translate(0,${yScale(value)})`" class="text-gray-400">
        <line x1="0" x2="100" stroke="currentColor" stroke-dasharray="6,5" stroke-width="0.5" vector-effect="non-scaling-stroke" />
      </g>
    </template>
  </svg>
</template>
